module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasicPopup', {
    attrs: {
      "title": "Saya ada siaran langsung gratis",
      "visible": _vm.visible
    },
    on: {
      "close": _vm.handleClose
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputVal),
      expression: "inputVal"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Silakan masukan"
    },
    domProps: {
      "value": (_vm.inputVal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputVal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "submit-btn",
    class: {
      disabled: !_vm.inputVal
    },
    attrs: {
      "disabled": !_vm.inputVal
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("\n                Memasuki\n            ")])]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Tampilan sumber langsung setelah ditinjau")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d592b352","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppLivePopup.vue
// module id = 701
// module chunks = 1